import {PolymerElement} from '@polymer/polymer';
import {ScopeBinding, ScopeRoot} from '../behaviors/keli-binding-behavior';
import {parseDateAndTime} from '@beauwest/business-date-parser';

class KeliCalendarController extends ScopeRoot(ScopeBinding(PolymerElement)) {
  static get is() {
    return 'keli-calendar-controller'
  }

  static get properties() {
    return {
      dataLoaded: {type: Boolean, value: false},
      element: {type: Object},
      manualKeliReady: {type: Boolean, value: true}
    }
  }

  constructor() {
    super();
    this.addOnKeli({
      'uicreateevent': 'handleCreateEvent',
      'uiupdateevent': 'handleUpdateEvent',
      'uideleteevent': 'handleDeleteEvent',
      'uiclearevents': 'handleClearEvents',
      'uicreatetimeline': 'handleCreateTimeline',
      'uicreatetimespan': 'handleCreateTimespan',
      'uideletetimespan': 'handleDeleteTimespan',
      'uiexporttopdf': 'handleExportToPDF',
      'uiexporttopng': 'handleExportToPNG',
      'uiexporttoexcel': 'handleExportToExcel'
    });
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.element = null;
  }

  async elementReady(element) {
    this.element = element;

    await this.changeKeliScopeRootName(this.element.keliname);
    await this.keliReady(this.element.getKeliScope());
  }

  async uuid(templateInstance) {
    templateInstance = this.getKeliTemplateInstance(templateInstance);
    return await this.runKeliFunctionIn(templateInstance, 'uuid');
  }

  async handleCreateEvent(event, templateInstance) {
    let defaultOptions = {
      id: await this.uuid(templateInstance),
      start_date: new Date(),
      text: 'New event'
    };
    Object.assign(defaultOptions, event.detail);

    if (defaultOptions.start_date) {
      defaultOptions.start_date = parseDateAndTime(defaultOptions.start_date);
    }
    if (defaultOptions.end_date) {
      defaultOptions.end_date = parseDateAndTime(defaultOptions.end_date);
    }
    this.element.formatEventColor(defaultOptions);
    this.element.scheduleInstance.addEvent(defaultOptions);
  }

  async handleUpdateEvent(event) {
    const existing = this.element.scheduleInstance.getEvent(event.detail.id);
    if (!existing) {
      return;
    }

    if (event.detail.start_date) {
      event.detail.start_date = parseDateAndTime(event.detail.start_date);
    }
    if (event.detail.end_date) {
      event.detail.end_date = parseDateAndTime(event.detail.end_date);
    }

    Object.assign(existing, event.detail);
    this.element.formatEventColor(existing);
    this.element.scheduleInstance.updateEvent(event.detail.id);
  }

  async handleDeleteEvent(event) {
    this.element.scheduleInstance.deleteEvent(event.detail.id);
  }

  async handleClearEvents() {
    this.element.scheduleInstance.clearAll();
  }

  async handleCreateTimeline(event) {
    this.element.createNewTimeline(event.detail);
  }

  async handleCreateTimespan(event) {
    this.element.createNewTimespan(event.detail);
  }

  async handleDeleteTimespan(event) {
    if (event.detail) {
      this.element.scheduleInstance.deleteMarkedTimespan(event.detail);
    } else {
      this.element.scheduleInstance.deleteMarkedTimespan();
    }
    this.element.scheduleInstance.updateView();
  }

  async handleExportToPDF(event) {
    this.element.exportToPDF(event.detail);
  }

  async handleExportToPNG(event) {
    this.element.exportToPNG(event.detail);
  }

  async handleExportToExcel(event) {
    this.element.exportToExcel(event.detail);
  }
}

customElements.define(KeliCalendarController.is, KeliCalendarController);
export {KeliCalendarController};
